module.exports = __webpack_public_path__ + "img/Linkedin Icon - charcoal.1bb5efee.svg";